module.exports = __webpack_public_path__ + "img/dev2.7556d078.jpg";